import Head from 'next/head';
import { useEffect, useRef, useState } from 'react';

export default function Kontakt() {
    const hasMeetingScriptLoaded = useRef(false);

    useEffect(() => {
        if (!hasMeetingScriptLoaded.current) {
            const meetingScript = document.createElement('script');
            meetingScript.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
            meetingScript.async = true;
            document.body.appendChild(meetingScript);
            hasMeetingScriptLoaded.current = true;
        }
    }, []);


    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>Termin | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Buchen Sie ein Termin, um mehr über meine SEO-Dienstleistungen zu erfahren. Nutzen Sie das Kontaktformular oder finden Sie meine Kontaktdaten auf der Kontaktseite. Dein SEO Expert freut sich darauf, von Ihnen zu hören und Ihnen weiterzuhelfen."
                />
            </Head>
            <main
                className="flex flex-col items-center justify-center flex-grow text-center p-6 gap-12">
                <div className="w-full">
                    <h1 className="text-4xl mb-4">Vereinbaren Sie einen Termin mit deinSEOExpert für professionellen SEO Service</h1>
                    <div className="meetings-iframe-container" data-src="https://meetings-eu1.hubspot.com/dennis-joch?embed=true"></div>
                </div>
            </main>
        </div>
    );
}
